import InfoBlock from 'components/UI/Blocks/InfoBlock'
import Button from 'components/UI/Buttons/Button'
import ContainerWithSteps from 'components/UI/Container/ContainerWithSteps'
import Document from 'components/UI/Document'
import Typography from 'components/UI/Typography'
import SigningLoader from 'components/views/Biometry/BiometryProcessing'
import { useAppSelector } from 'hooks'
import { useSigningLoader } from 'hooks/useSigningLoader'
import { Fragment, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useGetUnsignedDocumentsQuery } from 'redux/api/creditApi'
import { getNotificationsSelector } from 'redux/store/slices/wsSlice'
import { ApplicationEvents } from 'share/enums/events'
import tw from 'twin.macro'
import { downloadFileWithFetch, getWsStepStatus, getWsStepStatuses } from 'utils'
import { pathnames } from 'utils/constants'
import Emitter from 'utils/emitter'

const LOADER_QUERY_PARAM = 'show-signing-loader'

const RepaymentScheduleSign = () => {
  // Tools
  const navigate = useNavigate()
  const {
    t,
    i18n: { language }
  } = useTranslation()

  // Selectors
  const { SIGN_REPAYMENT_SCHEDULE_WITH_AITU } = useAppSelector(getNotificationsSelector)

  // Hooks
  const [showSigningLoader, removeLoaderSearchParam] = useSigningLoader(LOADER_QUERY_PARAM)

  // Queries
  const { data: repaymentScheduleData } = useGetUnsignedDocumentsQuery(['repayment_schedule'])

  // Handlers
  const goToNextStepPage = async () => {
    navigate(pathnames.biometry)
  }

  // Effects
  useEffect(() => {
    if (getWsStepStatus(SIGN_REPAYMENT_SCHEDULE_WITH_AITU) === 'DONE') {
      removeLoaderSearchParam()
      setTimeout(() => {
        Emitter.emit(ApplicationEvents.NAVIGATE_TO_NEXT_PAGE)
      }, 300)
    } else if (getWsStepStatuses(SIGN_REPAYMENT_SCHEDULE_WITH_AITU) === 'FAILED') {
      removeLoaderSearchParam()
    }
  }, [SIGN_REPAYMENT_SCHEDULE_WITH_AITU, removeLoaderSearchParam])

  return (
    <ContainerWithSteps>
      <div tw='flex flex-col mt-[12px] md:mt-0'>
        {showSigningLoader ? (
          <SigningLoader />
        ) : (
          <Fragment>
            <InfoBlock twStyle={tw`space-y-4`}>
              <Typography weight='bold'>{t('flow-schedule-sign')}</Typography>
              <Typography variant='subbody' text twStyle={tw`text-grey-dark`}>
                {t('flow-doc-sign-rule')}
              </Typography>
              {repaymentScheduleData && repaymentScheduleData?.length !== 0 && (
                <div tw='space-y-3'>
                  {repaymentScheduleData?.map(otherDoc => (
                    <Document
                      key={otherDoc?.id}
                      title={language === 'ru' ? otherDoc?.document_type_verbose : otherDoc?.document_type_verbose_kk}
                      twStyle={tw`border border-grey-light`}
                      onDownload={() => downloadFileWithFetch(otherDoc.id, otherDoc.document_type_verbose)}
                    />
                  ))}
                </div>
              )}
            </InfoBlock>
            <div tw='mx-4 md:mx-0 mt-5 md:ml-auto'>
              <Button variant='primary' twStyle={tw`min-w-[300px]`} onClick={goToNextStepPage}>
                <Typography weight='bold'> {t('flow-continue')}</Typography>
              </Button>
            </div>
          </Fragment>
        )}
      </div>
    </ContainerWithSteps>
  )
}

export default RepaymentScheduleSign
